import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PDFExtracterURL } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class DocumentExtractionService {
  private http = inject(HttpClient);

  /**
   * Sends a document file to the PDF Extracter microservice for OCR/parsing.
   * @param file         The uploaded PDF or image file.
   * @param documentType One of: PAN, AADHAAR, VOTER, DL, BANK_STATEMENT
   * @param consentToken Optional consent token (required for Aadhaar/Bank Statement).
   */
  extractDocument(
    file: File,
    documentType: string,
    consentToken: string = ''
  ): Observable<any> {
    const formData = new FormData();
    formData.append('File', file, file.name);
    formData.append('DocumentType', documentType);
    if (consentToken) {
      formData.append('ConsentToken', consentToken);
    }

    // Skip-Encryption header keeps multipart/form-data intact through the
    // encryption interceptor (consistent with other form-data services).
    const headers = new HttpHeaders({ 'Skip-Encryption': 'true' });

    return this.http.post<any>(PDFExtracterURL, formData, { headers });
  }
}
